var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_2626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12.4601C20 11.6211 19.9319 11.0088 19.7846 10.3739H10.2041V14.1607H15.8276C15.7143 15.1018 15.1021 16.519 13.7415 17.4713L13.7224 17.5981L16.7516 19.9448L16.9615 19.9657C18.8889 18.1857 20 15.5666 20 12.4601Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2041 22.4374C12.9591 22.4374 15.272 21.5303 16.9614 19.9658L13.7414 17.4714C12.8798 18.0723 11.7233 18.4918 10.2041 18.4918C7.50566 18.4918 5.21542 16.7118 4.39902 14.2515L4.27935 14.2616L1.12957 16.6993L1.08838 16.8138C2.76637 20.1471 6.21309 22.4374 10.2041 22.4374Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39905 14.2515C4.18363 13.6166 4.05897 12.9362 4.05897 12.2333C4.05897 11.5303 4.18363 10.8501 4.38772 10.2152L4.38201 10.08L1.19276 7.60315L1.08841 7.65278C0.39683 9.03602 0 10.5893 0 12.2333C0 13.8773 0.39683 15.4306 1.08841 16.8138L4.39905 14.2515Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2041 5.97485C12.1201 5.97485 13.4126 6.80251 14.1496 7.49417L17.0294 4.68236C15.2608 3.03837 12.9591 2.0293 10.2041 2.0293C6.21309 2.0293 2.76637 4.31953 1.08838 7.65284L4.38769 10.2152C5.21542 7.75492 7.50566 5.97485 10.2041 5.97485Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_2626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.2dc1de2247aea5695cdc84bf7fa074d8.svg";
export { ForwardRef as ReactComponent };